module.exports = __webpack_public_path__ + "img/1752629758648-abe81664-e467-4753-8221-07593710b2ad.jpeg.c52f061d.webp";